import React from 'react';
import {Button} from "@mui/material";
import {FormattedMessage} from "react-intl";
import RefreshIcon from '@mui/icons-material/Refresh';

type RefreshButtonProps = {
    onClick: () => void;
    color?: string;
};

const RefreshButton: React.FC<RefreshButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "primary"}
            startIcon={<RefreshIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_REFRESH'}/>
        </Button>
    );
};
export default RefreshButton;
